module.exports = __webpack_public_path__ + "img/icon_bluesky.d00e6946.png";